var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7 16.94c-1.25 0-3.77.48-4.86 0-.94-.43-.59-2 .16-2.5a6.26 6.26 0 0 1 4.7-.85.3.3 0 0 0 .08-.59 7 7 0 0 0-5.19.84c-1.21.82-1.64 3.09-.09 3.84 1.32.64 3.82.21 5.21.24a68.56 68.56 0 0 1 11 .56c1.27.21 4.31 1.2 3.88 2.42-.34 1-2.42 1-3.43 1.07-3.65.28-7.3.69-10.95.73-.57 0-5.88.27-6.12.8a.31.31 0 0 0 .07.39c.32.3-.43-.09 4.51-.35 1.62-.09 2.44 0 6-.14 2.2-.1 4.39-.27 6.59-.39a9.49 9.49 0 0 0 3.23-.51 2 2 0 0 0 .52-3.42C19.3 16.39 11.1 16.89 7 16.94Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.21 11.61a.34.34 0 1 0 .47.49c.35-.24.72-.42 1.05-.69.81-.66.76-1.07 1-1.3a1.39 1.39 0 0 0 1.14.07 1.71 1.71 0 0 0 .91-1.54 1.91 1.91 0 0 0-.3-.75c-1-1.53-4-.33-2.3 1.74a6 6 0 0 0-1.97 1.98Zm2.86-3.35c1-.42 1.41.94.53 1.13a.56.56 0 0 1-.43-.15c-.06-.08-.59-.79-.1-.98Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.65 6.18-1.06.73a30.38 30.38 0 0 0-5.75-5.5c.16-.31.29-.62.42-.94a.3.3 0 0 0-.49-.34 4.86 4.86 0 0 0-1.91 2.6.34.34 0 0 0 .59.33c.34-.39.61-.56 1.06-1.12.87.87 1.65 1.9 2.5 2.77 1.11 1.12 2.41 2.06 3 2.59-1.33.76-1.53 1-2.39.32-1.22-.93-1.4-1.62-2.55-2.25L14.5 4a.3.3 0 0 0-.43.41l.3.34a3.84 3.84 0 0 0-4.07 2.38c-.64 1.48-1.65 5-.68 6.26a.29.29 0 0 0 .48-.34c-.77-1.18.69-5.48 1.72-6.42 2.82-2.67 7.61 2 4.5 4.67a15.33 15.33 0 0 1-5 1.88.34.34 0 0 0 .1.67A16.34 16.34 0 0 0 16.91 12a3.56 3.56 0 0 0 1.49-3.15 1.92 1.92 0 0 0 1 .27c.59 0 1-.14 3.7-2.41a.34.34 0 1 0-.45-.53Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriting);
export default __webpack_public_path__ + "static/media/writing.d15cdc63bc94b161ac0779c67932b1c0.svg";
export { ForwardRef as ReactComponent };